module.exports = __webpack_public_path__ + "img/router_pchome.f258d1ae.jpg";